import React, { useLayoutEffect, useRef, useState } from "react";
import { formatterCurrency } from "../../../../utils/formatacaoNumeros";
import { zoomEfetivo } from "../../../../utils/zoomEfetivo";
import { FONTE, NAVY, SUAVE } from "../estilos/tokens";

const FONTE_MAXIMA = 29;
const PROPORCAO_ROTULO = 0.55;
const ALTURA_LINHA = 1.2;
const ESPACO_ENTRE_LINHAS = 0.15;
const ALTURA_BLOCO_EM = ALTURA_LINHA + ESPACO_ENTRE_LINHAS + PROPORCAO_ROTULO * ALTURA_LINHA;
const FOLGA_DO_FURO = 0.88;
const LARGURA_ESTIMADA_POR_CARACTERE = 0.62;
const FONTE_REFERENCIA = 100;

/**
 * O bloco de texto e um retangulo inscrito no circulo do furo: a diagonal nao pode passar do diametro.
 */
export const tamanhoFonteTotal = (larguraEm: number, diametroFuro: number) => {
  const cabe = (diametroFuro * FOLGA_DO_FURO) / Math.hypot(larguraEm, ALTURA_BLOCO_EM);
  const valor = Math.max(0, Math.min(FONTE_MAXIMA, Math.floor(cabe * 2) / 2));
  return { valor, rotulo: valor * PROPORCAO_ROTULO };
};

interface Props {
  total: number;
  diametroFuro: number;
}

const TotalRosca = ({ total, diametroFuro }: Props) => {
  const texto = formatterCurrency(total);
  const refReferencia = useRef<HTMLSpanElement>(null);
  const [larguraEm, setLarguraEm] = useState(() => texto.length * LARGURA_ESTIMADA_POR_CARACTERE);
  const fonte = tamanhoFonteTotal(larguraEm, diametroFuro);

  // Mede num tamanho fixo: medir no tamanho exibido realimenta a fonte e pode oscilar sem fim
  useLayoutEffect(() => {
    let ativo = true;
    const medir = () => {
      const elemento = refReferencia.current;
      if (!ativo || !elemento) {
        return;
      }
      const largura = elemento.getBoundingClientRect().width / zoomEfetivo(elemento);
      if (largura > 0) {
        const medida = largura / FONTE_REFERENCIA;
        setLarguraEm((atual) => (Math.abs(atual - medida) > 0.01 ? medida : atual));
      }
    };
    medir();
    // A largura muda quando a fonte web termina de carregar
    const fontes = (document as any).fonts;
    if (fontes && fontes.ready) {
      fontes.ready.then(medir);
    }
    return () => {
      ativo = false;
    };
  }, [texto]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        visibility: diametroFuro > 0 ? "visible" : "hidden",
      }}
    >
      <div aria-hidden style={{ position: "absolute", width: 0, height: 0, overflow: "hidden", visibility: "hidden" }}>
        <span
          ref={refReferencia}
          style={{
            position: "absolute",
            fontFamily: FONTE,
            fontSize: FONTE_REFERENCIA,
            fontWeight: 700,
            whiteSpace: "nowrap",
          }}
        >
          {texto}
        </span>
      </div>
      <span
        style={{
          fontFamily: FONTE,
          fontSize: fonte.valor,
          fontWeight: 700,
          color: NAVY,
          lineHeight: ALTURA_LINHA,
          whiteSpace: "nowrap",
        }}
      >
        {texto}
      </span>
      <span
        style={{
          fontFamily: FONTE,
          fontSize: fonte.rotulo,
          fontWeight: 500,
          color: SUAVE,
          letterSpacing: 1,
          lineHeight: ALTURA_LINHA,
          marginTop: fonte.valor * ESPACO_ENTRE_LINHAS,
        }}
      >
        TOTAL
      </span>
    </div>
  );
};

export default TotalRosca;
